export const SIDEBAR_VIEWS = {
  DETAILS: "DETAILS",
};
